// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"2aaa41da","354":"0cef624e","418":"ca7c0421"}[chunkId] + ".js";
};